(function ($) {
  $(document).ready(function () {
    $(".customize .customize-title").click(function () {
      var parent = $(this).parent();
      parent.toggleClass("active");
      if (parent.hasClass("active")) {
        var width = parent.data("width");
        var height = parent.data("height");
        parent.css("width", width + "px");
        parent.css("height", height + "px");
        $(".bg").css("width", width + "px");
        $(".bg").css("height", height + "px");
      } else {
        var width = $(this).outerWidth(true);
        var height = $(this).outerHeight(true);
        parent.css("width", width + "px");
        parent.css("height", height + "px");
        $(".bg").css("width", width + "px");
        $(".bg").css("height", height + "px");
      }
    });

    $(".customize").each((index, e) => {
      var element = $(e);
      console.log(element);
      var title = element.find(".customize-title");

      element.data("width", element.width());
      element.data("height", element.height());

      var bg = element.find(".bg");

      bg.css("width", title.outerWidth(true) + "px");
      bg.css("height", title.outerHeight(true) + "px");
      element.css("width", title.outerWidth(true) + "px");
      element.css("height", title.outerHeight(true) + "px");
    });

    handleAddGiftBoxCheckbox();
    // getRiseData();
    handleInterceptQuantityChange();
  });
})(jQuery);

function handleTermsAndCheckout() {
  var checkboxDom = $(".terms-checkbox input");
  var checkoutBtnDom = $(".cart__checkout-button");
  // disable by default
  checkoutBtnDom.attr("disabled", true);
  checkoutBtnDom.addClass("disabled");
  checkboxDom.on("click", function (e) {
    var input = e.target;
    if (input.checked) {
      checkoutBtnDom.removeClass("disabled");
      checkoutBtnDom.removeAttr("disabled");
    } else {
      checkboxBtnDom.addClass("disabled");
      checkoutBtnDom.attr("disabled", true);
    }
  });
}

function handleAddGiftBoxCheckbox() {
  var checkboxDom = $(".gift-checkbox input");
  var giftBoxContainerDom = $(".cart__giftbox-container");
  if (checkboxDom) {
    checkboxDom.on("click", function (e) {
      var input = e.target;
      if (input.checked) {
        $.ajax({
          type: "POST",
          url: "/cart/add.js",
          data: {
            id: window.giftBoxVariantId,
            quantity: 1,
          },
          dataType: "json",
          success: function (data) {
            console.log("Gift box added to cart:", data);
            // reload the page to reflect changes
            location.reload();
          },
          error: function (error) {
            console.error("Error adding gift box to cart:", error);
          },
        });
        // giftBoxContainerDom.show();
      } else {
        // remove gift box from cart
        $.ajax({
          type: "GET",
          url: "/cart.js",
          dataType: "json",
          success: function (cart) {
            const giftBoxItem = cart.items.find(
              (item) => item.variant_id === window.giftBoxVariantId
            );
            if (giftBoxItem) {
              $.ajax({
                type: "POST",
                url: "/cart/change.js",
                data: {
                  id: giftBoxItem.key,
                  quantity: 0,
                },
                dataType: "json",
                success: function (data) {
                  console.log("Gift box removed from cart:", data);
                  // reload the page to reflect changes
                  location.reload();
                },
                error: function (error) {
                  console.error("Error removing gift box from cart:", error);
                },
              });
            }
          },
        });
        // giftBoxContainerDom.hide();
      }
    });
  }
  // checkboxDom.on("click", function (e) {
  //   var input = e.target;
  //   if (input.checked) {
  //     console.log("checked");
  //     // giftBoxContainerDom.show();
  //   } else {
  //     // giftBoxContainerDom.hide();
  //   }
  // }
}

// need to intercept quantity input change to refresh the cart with new quantity
function handleInterceptQuantityChange() {
  const originalFetch = window.fetch;
  window.fetch = async (...args) => {
    const response = await originalFetch(...args);
    if (typeof args[0] === "string" && args[0].includes("/cart/change")) {
      const cloned = response.clone();
      cloned.json().then((data) => {
        // getRiseData();
        location.reload();
      });
    }
  };
}

function handleClickCheckoutStoreCredits(discount) {
  // if the user clicks on checkout with store credits, save the unique id into the checkout
  if (!discount) {
    return;
  }
  document.cookie = `discount_code=${discount}`;
  $(".rise-quick-apply-container .loading-overlay__spinner").show();
  // cart_link_id=Zvxh1LLB&discount=db775cc2fe6f9e8d&preview_theme_id=174719861020&riseDiscount=true
  let getParams = `&discount=${discount}&riseDiscount=true`;
  if (localStorage && localStorage.getItem("cart_link_id")) {
    const cartLinkId = localStorage.getItem("cart_link_id");
    getParams += getParams + `&cart_link_id=${cartLinkId}`;
  }
  setTimeout(() => {
    window.location.href = `/discount/${discount}/?redirect=/checkout${getParams}`;
  }, 1000);
}

function copyText(e, text) {
  const currentHtmlText = $(e).html();
  // copy the text
  navigator.clipboard.writeText(text);
  $(e).html("COPIED!");
  setTimeout(() => {
    $(e).html(currentHtmlText);
  }, 2000);
}

function getRiseData() {
  $.ajax({
    type: "GET",
    url: "/apps/rise-ai/customer",
    success: function (data) {
      // remove loading spinner
      const GiftCardInfo = data?.LoyaltyCard?.GiftCard;
      console.log(GiftCardInfo);
      const spinner = $(
        ".rise-quick-apply-container .loading-overlay__spinner"
      );
      const riseHtmlContainer = $(".rise-info-container");
      const riseHtmlButton = $(".rise-button-container");
      spinner.hide();
      if (GiftCardInfo?.balance) {
        riseHtmlContainer.html(
          `You have <strong>$${GiftCardInfo?.balance}</strong> left in Store Credits. Copy and paste code at checkout:`
        );
        // we disable this one first until we can get a better solution
        // riseHtmlButton.html(
        //   `<a href="#" onclick="handleClickCheckoutStoreCredits('${GiftCardInfo?.code}')" class="disabled cart__checkout-button button color-pantone-ga" style="width:100%">Checkout with Store credits</a>`
        // );
        riseHtmlButton.html(
          `<div class="rise-copy-container color-pantone-ga">
            <div>${GiftCardInfo?.code}</div>
            <button class="rise-copy__button" onclick="copyText(this,'${GiftCardInfo?.code}')">COPY</button>
          </div>`
        );
        handleTermsAndCheckout();
      }
    },
  });
}
